// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ld-1";
export var quotedThread = "_ld-0";